// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1zZv4","content":"RecentSearches_content__1gDr-"};